import { collection, addDoc, getDocs, query, where } from "firebase/firestore";

import { db } from "../firebase/config";

export const saveInvoice = async (invoiceData) => {
  await addDoc(collection(db, "invoices"), invoiceData);
};

export const getInvoices = async (gymId) => {
  const q = query(collection(db, "invoices"), where("gymId", "==", gymId));

  const snapshot = await getDocs(q);

  const invoices = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  invoices.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  return invoices;
};
